import { render } from "./HighlightPopup.vue?vue&type=template&id=4bd131d8&scoped=true&ts=true"
import script from "./HighlightPopup.vue?vue&type=script&lang=ts"
export * from "./HighlightPopup.vue?vue&type=script&lang=ts"

import "./HighlightPopup.vue?vue&type=style&index=0&id=4bd131d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd131d8"]])

export default __exports__